import { render, staticRenderFns } from "./MasterBidangHistory.vue?vue&type=template&id=74d297fe&"
import script from "./MasterBidangHistory.vue?vue&type=script&lang=js&"
export * from "./MasterBidangHistory.vue?vue&type=script&lang=js&"
import style0 from "./MasterBidangHistory.vue?vue&type=style&index=0&id=74d297fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports